import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { UserCheck } from "lucide-react";

const CLS = { non_propose: "bg-slate-100 text-slate-600", a_inviter: "bg-orange-100 text-orange-800", invitation_envoyee: "bg-blue-100 text-blue-800", compte_active: "bg-green-100 text-green-800", refuse: "bg-slate-200 text-slate-600" };

// Bloc « Accès patient » (chauffeur / régulation) : email + statut + « Proposer l'accès Espace patient ». N'envoie jamais l'invitation (rôle de la régulation).
export function PatientAccessBlock({ patientId, testid = "patient-access" }) {
  const [st, setSt] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/patients/${patientId}/portal-access`).then((r) => { setSt(r.data); setEmail(r.data.email || ""); }).catch(() => {});
  useEffect(() => { if (patientId) load(); }, [patientId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!st || !st.enabled) return null;
  const propose = async () => {
    if (!email.includes("@")) return toast.error("Email du patient requis");
    setBusy(true);
    try { await api.post(`/patients/${patientId}/portal-request`, { email }); toast.success("Accès proposé : la régulation vérifiera et enverra l'invitation"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail) || e.message); } finally { setBusy(false); }
  };
  return (
    <div data-testid={testid} className="rounded-xl border border-slate-200 bg-white p-3 space-y-2">
      <div className="flex items-center justify-between gap-2"><p className="text-sm font-bold text-brand-900 flex items-center gap-1.5"><UserCheck className="w-4 h-4" />Accès patient</p><span data-testid={`${testid}-status`} className={`text-xs font-bold px-2 py-0.5 rounded-full ${CLS[st.status]}`}>{st.status_label}</span></div>
      {(st.status === "non_propose" || st.status === "refuse") ? (
        <div className="flex gap-2"><Input data-testid={`${testid}-email`} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email du patient" className="h-11 flex-1" /><button data-testid={`${testid}-propose`} onClick={propose} disabled={busy} className="h-11 px-3 rounded-lg bg-accent-600 text-white text-xs font-bold">Proposer l'accès Espace patient</button></div>
      ) : <p className="text-xs text-slate-500">{st.email}</p>}
    </div>
  );
}
